<template>
	<div class="quesstion">
        <div class="title"><span style="color:red">*</span>{{sortNum}}、{{questionData.question}}<span style="color:#ccc">{{questionData.tip}}</span></div>
        <div class="answer">
            <div class="child d-flex" v-for="(item,index) in childlist" :key="index" @click="getSorting(item,index)">
                <div class="child-l">
                    <div class="choose color1" v-if="!item.show"></div>
                    <div class="choose color2" v-else>{{item.number}}</div>
                </div>
                <div class="child-r">{{item.name}}</div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    name: "sorting",
    props: {
		questionData:{
			type:Object,
			default:{}
        },
        sortNum:{
            type:Number,
            default:0
        },
        isReset:{
            type:Boolean,
            default:false
        }
    },
    watch:{
        questionData:{
            handler(newVal,oldVal){
                for(let item of this.questionData.options){
                    let val={
                        name:item,
                        show:false,
                        number:null
                    }
                    this.childlist.push(val)
                }
            },
            deep:true,
            immediate:true
        },
        isReset:{
            handler(newVal,oldVal){
                if(newVal){
                    for(let item in this.childlist){
                        this.childlist[item].show=false;
                        this.childlist[item].number = null;
                    }
                    this.sort=0;
                    this.valList = [];
                }
            },
            immediate:true
        }
    },
    data() {
        return {
            childlist:[],
            sort:0,
            valList:[]
        }
    },
    mounted() {
        
    },
    methods: {
        getSorting(val,index){
            if(val.show){
                for(let item in this.childlist){
                    this.childlist[item].show=false;
                    this.childlist[item].number = null;
                }
                this.sort=0;
                // for(let item in this.childlist){
                //     if(val.number!==null&&this.childlist[item].number>val.number){
                //         --this.childlist[item].number;
                //         console.log(this.childlist[item].number,val.number)
                //     }else if(this.childlist[item].name===val.name){
                //         this.childlist[item].show=false;
                //         this.childlist[item].number = null;
                //     }
                // }
                // this.sort--;
            }else{
                this.childlist[index].show=true;
                this.childlist[index].number = ++this.sort;
            }
            
            //克隆数组
            Object.assign(this.valList,this.childlist);
            for(let val in this.valList){
                if(this.valList[val].number === null){
                    this.valList.splice(val,1)
                }
            }
            this.valList.sort(this.compare('number'))
            if(this.valList.length===this.childlist.length){
               this.getSortingval(this.valList);
            }
        },
        //排序
        compare(property){
            return function(a,b){
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        //
        getSortingval(values){
            let opts = [];
            for(let item of values){
                opts.push({"answer":item.name})
            }
            let parms = {
                    id:this.questionData.id,
                    questionnaireIssuesId:this.questionData.questionnaireIssuesId,
                    options:opts
                }
            this.$emit('getSortingdata',parms);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/questionnaire/questionSorting.vue